const jsonArray = require(`../../../projects/${process.env.PROJECT}/front/configs/types/aereoporti.json`)

export default () => {
  const items = jsonArray.map(elem => {
    return {
      id: elem[0],
      name: elem[1]
    }
  })
  return items.sort(function (a, b) {
    return +(a.name > b.name) || -1
  })
}



// WEBPACK FOOTER //
// ./src/front/actions/types/get-types-aereoporti.js